// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-page {
  /* Height of the bottom strip — the illustration rests on top of it rather
     than being buried under it. Kept in sync with .auth-footer's padding and
     line count at each breakpoint. */
  --auth-strip-h: 46px;
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(150deg, #eef4fd 0%, #f8fbff 45%, #eaf1fb 100%);
  overflow: hidden;
}

/* ============================================================
   Layout has two modes, switched at one breakpoint (1100px):

   MOBILE / TABLET  — single column. Centred card, with the illustration
                      pinned to the page bottom as a background (it takes
                      no layout space; main reserves a little room above
                      it so the card never covers the artwork).
   DESKTOP          — the reference composition. Hero copy on the
                      left, card on the right, illustration pinned to
                      the page's bottom-left, and the floating dots /
                      bubbles / dot-grids at the reference's exact
                      coordinates (percentages of its 1555x1011 canvas).
   ============================================================ */

/* Decorative dots/bubbles are tuned to the desktop composition, so they
   stay off on smaller screens rather than landing on top of the card. */
.auth-decor { display: none; }

.auth-illustration {
  position: absolute;
  left: 0;
  right: 0;
  bottom: var(--auth-strip-h);
  margin: 0 auto;
  width: min(100%, 580px);
  z-index: 1;
  pointer-events: none;
}

@media (min-width: 1100px) {
  .auth-decor {
    display: block;
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none;
  }
  .auth-illustration {
    /* The art belongs to the hero column, so it starts on the same left edge
       as the headline and ends where the column does — anything bleeding to
       the page edge reads as misaligned against the copy above it.
       (1440px container, its side padding, then the card's 500px + the 60px
       gap make up the rest of the row.) */
    --auth-gutter: calc(max(0px, (100vw - 1440px) / 2) + clamp(16px, 4vw, 56px));
    --auth-hero-w: calc(
      min(100vw, 1440px)
      - 2 * clamp(16px, 4vw, 56px)   /* the container's side padding */
      - 500px                         /* the sign-in card */
      - clamp(24px, 4vw, 64px)        /* .auth-main's column gap */
    );
    left: var(--auth-gutter);
    right: auto;
    margin: 0;
    /* Width drives height (the art is ~1.78:1) and it is pinned to the
       bottom, so on a short window it climbs into the hero copy and the
       badges land on the text. Cap the width by the room actually left
       above the fold. */
    width: min(var(--auth-hero-w), calc((100vh - 330px - var(--auth-strip-h)) * 1.95));
  }
}

/* ---------- floating dots ---------- */
.auth-dot {
  position: absolute;
  border-radius: 50%;
  animation: auth-dot-float 6s ease-in-out infinite;
}
.auth-dot-teal { background: #5eead4; }
.auth-dot-sky { background: #7dd3fc; }
.auth-dot-blue { background: #2563eb; }
.auth-dot-amber { background: #fbbf24; }

.auth-dot-1 { left: 47.9%; top: 5.0%;  width: 9px;  height: 9px; }
.auth-dot-2 { left: 96.7%; top: 4.9%;  width: 9px;  height: 9px;  animation-delay: -1.2s; }
.auth-dot-3 { left: 57.2%; top: 30.4%; width: 15px; height: 15px; animation-delay: -2.4s; }
.auth-dot-4 { left: 52.1%; top: 39.4%; width: 7px;  height: 7px;  animation-delay: -3.6s; }
.auth-dot-5 { left: 94.7%; top: 15.2%; width: 9px;  height: 9px;  animation-delay: -4.8s; }
.auth-dot-6 { left: 96.9%; top: 79.2%; width: 9px;  height: 9px;  animation-delay: -2.0s; }

@keyframes auth-dot-float {
  0%, 100% { transform: translateY(0); opacity: 0.8; }
  50% { transform: translateY(-6px); opacity: 1; }
}

/* ---------- dotted grid patches ---------- */
.auth-grid {
  position: absolute;
  background-image: radial-gradient(rgba(96, 165, 250, 0.4) 1.6px, transparent 1.6px);
  background-size: 13px 13px;
}
.auth-grid-1 { left: 42.4%; top: 7.7%;  width: 86px; height: 66px; }
.auth-grid-2 { left: 95.8%; top: 54.9%; width: 62px; height: 72px; }
.auth-grid-3 { left: 95.0%; top: 68.2%; width: 74px; height: 86px; }

/* ---------- faint ring on the right ---------- */
.auth-ring {
  position: absolute;
  left: 90.5%;
  top: 21%;
  width: 280px;
  height: 280px;
  border-radius: 50%;
  border: 1px solid rgba(147, 197, 253, 0.22);
}

/* ---------- dashed connector between the plane bubble and its dot ---------- */
.auth-connector {
  position: absolute;
  left: 51.4%;
  top: 27.4%;
  width: 6.6%;
  height: 4.2%;
}

/* ---------- icon bubbles ---------- */
.auth-bubble {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(219, 234, 254, 0.9);
  box-shadow: 0 16px 32px -20px rgba(30, 64, 175, 0.5);
  color: #3b82f6;
  animation: auth-bubble-float 7s ease-in-out infinite;
}
.auth-bubble-box   { left: 53.3%; top: 6.7%;  width: 58px; height: 58px; }
.auth-bubble-plane { left: 47.6%; top: 23.7%; width: 72px; height: 72px; animation-delay: -2.3s; }
.auth-bubble-cube  {
  left: 94.5%;
  top: 36.3%;
  width: 72px;
  height: 72px;
  color: #8b5cf6;
  background: rgba(246, 244, 255, 0.78);
  border-color: rgba(221, 214, 254, 0.9);
  animation-delay: -4.6s;
}
.auth-bubble-mini  { left: 47.0%; top: 50.9%; width: 38px; height: 38px; animation-delay: -1.1s; }
/* On narrower desktops the card reaches the right gutter, so the cube
   bubble would sit half-hidden behind it — drop it until there's room. */
@media (max-width: 1399px) {
  .auth-bubble-cube { display: none; }
}
.auth-bubble-mini-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #93c5fd;
}

@keyframes auth-bubble-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-9px); }
}

/* ---------- illustration + its status badges ---------- */
/* The source artwork is far more saturated than the reference comp, which
   shows it as a pale, hazy scene that dissolves into the page. Desaturating
   and fading the right edge reproduces that, and keeps the artwork from
   competing with the login card. */
.auth-illustration-img {
  display: block;
  width: 100%;
  height: auto;
  opacity: 0.88;
  filter: saturate(0.78) brightness(1.04);
  /* The art feathers out on three sides but the sea and road are sliced
     straight across at 98% of its height. Push that strip past the bottom of
     the page (which clips it) so the scene bleeds off the edge instead of
     ending on a line. */
  margin-bottom: -2.5%;
}
/* This artwork already feathers out on its own left and bottom — only the
   plane's nose grazes the right edge of the canvas (at 30-32% of its height),
   which would read as a straight cut. Soften just that strip; fading any more
   washes the plane and truck out. */
/* The art feathers out on its own left and top, and the sliced bottom is
   pushed off the page (see margin-bottom above) — but the road and cloud bank
   still run solid into the right edge of the canvas, which reads as a straight
   cut in the middle of the page. Fade just the last tenth: the truck ends at
   88% so it stays sharp. Re-check the edges if the artwork is replaced. */
.auth-illustration-img {
  mask-image: linear-gradient(to right, #000 0%, #000 97%, transparent 100%);
}

.auth-badge {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 9px;
  background: #ffffff;
  border-radius: 13px;
  padding: 9px 14px 9px 10px;
  box-shadow: 0 16px 30px -16px rgba(15, 23, 42, 0.38);
  white-space: nowrap;
  animation: auth-badge-bob 6s ease-in-out infinite;
}
/* Each badge is anchored just clear of the vehicle it labels — in the artwork
   the ship sits at 5-31% / 60-88%, the plane at 50-97% / 8-33% and the truck
   at 70-88% / 70-88% — so they read as callouts instead of floating loose. */
.auth-badge-ship   { left: 9%;  top: 47%; animation-delay: -1s; }
.auth-badge-ontime { left: 24%; top: 19%; animation-delay: -3s; }
.auth-badge-truck  { left: 50%; top: 63%; animation-delay: -5s; }

.auth-badge-icon {
  width: 30px;
  height: 30px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.auth-badge-icon-soft { background: #e0f2fe; color: #0284c7; }
.auth-badge-icon-solid { background: #2563eb; color: #ffffff; }
.auth-badge-icon-dark { background: #f1f5f9; color: #334155; }

.auth-badge-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.25;
}
.auth-badge-sub { font-size: 0.72rem; color: #94a3b8; line-height: 1.25; }
.auth-badge-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }
.auth-badge-dot-green { background: #22c55e; animation: auth-pulse-dot 1.8s ease-in-out infinite; }
.auth-badge-dot-orange { background: #f97316; animation: auth-pulse-dot 1.8s ease-in-out infinite; animation-delay: -0.9s; }

@keyframes auth-badge-bob {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}

/* Badges scale down with the smaller illustration on tablets, and drop out
   on phones where the art is too small to carry three callouts. */
@media (max-width: 1099px) {
  .auth-badge { padding: 7px 11px 7px 8px; gap: 7px; border-radius: 11px; }
  .auth-badge-icon { width: 26px; height: 26px; border-radius: 8px; }
  .auth-badge-title { font-size: 0.72rem; }
  .auth-badge-sub { font-size: 0.66rem; }
}
@media (max-width: 639px) {
  .auth-badge { display: none; }
}

/* ---------- main layout ---------- */
.auth-main {
  position: relative;
  z-index: 2;
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(24px, 4vw, 64px);
  /* Bottom padding keeps the card clear of the artwork pinned below it.
     The art's top ~24% is transparent sky, so a small overlap is harmless
     on very short viewports. */
  padding: clamp(32px, 5vw, 72px) clamp(16px, 4vw, 56px) clamp(130px, 27vw, 210px);
  max-width: 1440px;
  margin: 0 auto;
  width: 100%;
}

.auth-hero { display: none; }
.auth-card-slot {
  width: 100%;
  max-width: 500px;
  display: flex;
  justify-content: center;
}

@media (min-width: 1100px) {
  .auth-main { align-items: stretch; padding-top: 0; padding-bottom: 0; }
  .auth-hero {
    display: block;
    flex: 1 1;
    min-width: 0;
    /* Carries the row's top padding on its own, so the card beside it stays
       centred between the top of the page and the strip. */
    padding-top: calc(clamp(20px, 3.5vw, 44px) + clamp(14px, 2.2vw, 34px));
  }
  .auth-card-slot {
    flex: 0 0 auto;
    align-items: center;   /* equal room above and below the card */
    padding-top: 0;
  }
}

/* ---------- hero copy ---------- */
.auth-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #ecfdf3;
  color: #15803d;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 7px 15px;
  border-radius: 999px;
  margin-bottom: 20px;
}
.auth-pill-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #22c55e;
  animation: auth-pulse-dot 1.8s ease-in-out infinite;
}
@keyframes auth-pulse-dot {
  0%, 100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55); }
  50% { box-shadow: 0 0 0 5px rgba(34, 197, 94, 0); }
}

.auth-headline {
  font-size: clamp(2.2rem, 3.5vw, 3.25rem);
  font-weight: 800;
  color: #0f172a;
  line-height: 1.1;
  letter-spacing: -0.02em;
  margin: 0 0 16px;
}
.auth-headline-accent { color: #2563eb; }

.auth-subtext {
  max-width: 480px;
  color: #64748b;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0 0 28px;
}

.auth-modes {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 18px;
  font-size: 0.82rem;
  font-weight: 600;
  color: #334155;
  letter-spacing: 0.01em;
}
.auth-mode {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
.auth-modes-sep { color: #93c5fd; }

/* ---------- footer ---------- */
.auth-footer {
  position: relative;
  z-index: 3;
  padding: 13px 0;
  font-size: 0.74rem;
  color: #64748b;
  /* The artwork runs underneath, so the strip needs its own ground rather
     than a halo behind each word. */
  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-top: 1px solid rgba(226, 232, 240, 0.9);
}
/* Same max-width and side padding as .auth-main, so the first service point
   starts on the hero headline's edge and the tagline ends on the card's. */
.auth-footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 clamp(16px, 4vw, 56px);
}

.auth-footer-item { display: flex; align-items: center; gap: 10px; white-space: nowrap; }

.auth-footer-item-right { flex-direction: row-reverse; }
.auth-footer-line { width: 30px; height: 2px; background: #60a5fa; border-radius: 1px; flex-shrink: 0; }

/* Below desktop the footer sits over the busiest part of the pinned
   artwork (ship/truck), so it gets a soft fade-to-page backdrop that also
   dissolves the art's hard bottom edge. */
@media (max-width: 1099px) {
  .auth-page { --auth-strip-h: 66px; }
  .auth-modes { font-size: 0.76rem; gap: 6px 14px; }
}
/* On a phone the four points need the whole strip; the tagline drops out and
   the points pair up two per row instead of stacking four deep. */
@media (max-width: 639px) {
  .auth-page { --auth-strip-h: 56px; }
  .auth-footer-item-right { display: none; }
  .auth-footer { padding: 10px 0; }
  .auth-footer-inner { padding: 0 14px; }
  .auth-modes {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 4px 8px;
    font-size: 0.62rem;
  }
  .auth-mode { white-space: normal; gap: 6px; }
}
@media (max-width: 480px) {
  .auth-footer { font-size: 0.62rem; padding-left: 16px; padding-right: 16px; }
  .auth-footer-line { width: 14px; }
}

/* ---------- reduced motion ---------- */
@media (prefers-reduced-motion: reduce) {
  .auth-dot,
  .auth-bubble,
  .auth-badge,
  .auth-badge-dot-green,
  .auth-badge-dot-orange,
  .auth-pill-dot {
    animation: none !important;
  }
}

@media (max-width: 1279px) and (min-width: 1100px) {
  .auth-modes { max-width: 380px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Login/AuthLayout.css"],"names":[],"mappings":"AAAA;EACE;;qCAEmC;EACnC,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,0EAA0E;EAC1E,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;iEAYiE;;AAEjE;wEACwE;AACxE,cAAc,aAAa,EAAE;;AAE7B;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,oBAAoB;EACtB;EACA;IACE;;;;0CAIsC;IACtC,4EAA4E;IAC5E;;;;;KAKC;IACD,wBAAwB;IACxB,WAAW;IACX,SAAS;IACT;;;wBAGoB;IACpB,kFAAkF;EACpF;AACF;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iDAAiD;AACnD;AACA,iBAAiB,mBAAmB,EAAE;AACtC,gBAAgB,mBAAmB,EAAE;AACrC,iBAAiB,mBAAmB,EAAE;AACtC,kBAAkB,mBAAmB,EAAE;;AAEvC,cAAc,WAAW,EAAE,SAAS,GAAG,UAAU,GAAG,WAAW,EAAE;AACjE,cAAc,WAAW,EAAE,SAAS,GAAG,UAAU,GAAG,WAAW,GAAG,sBAAsB,EAAE;AAC1F,cAAc,WAAW,EAAE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE,sBAAsB,EAAE;AAC1F,cAAc,WAAW,EAAE,UAAU,EAAE,UAAU,GAAG,WAAW,GAAG,sBAAsB,EAAE;AAC1F,cAAc,WAAW,EAAE,UAAU,EAAE,UAAU,GAAG,WAAW,GAAG,sBAAsB,EAAE;AAC1F,cAAc,WAAW,EAAE,UAAU,EAAE,UAAU,GAAG,WAAW,GAAG,sBAAsB,EAAE;;AAE1F;EACE,WAAW,wBAAwB,EAAE,YAAY,EAAE;EACnD,MAAM,2BAA2B,EAAE,UAAU,EAAE;AACjD;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,mFAAmF;EACnF,0BAA0B;AAC5B;AACA,eAAe,WAAW,EAAE,SAAS,GAAG,WAAW,EAAE,YAAY,EAAE;AACnE,eAAe,WAAW,EAAE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE;AACnE,eAAe,WAAW,EAAE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE;;AAEnE,kDAAkD;AAClD;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,oDAAoD;EACpD,cAAc;EACd,oDAAoD;AACtD;AACA,qBAAqB,WAAW,EAAE,SAAS,GAAG,WAAW,EAAE,YAAY,EAAE;AACzE,qBAAqB,WAAW,EAAE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE,sBAAsB,EAAE;AACjG;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,sCAAsC;EACtC,sBAAsB;AACxB;AACA,qBAAqB,WAAW,EAAE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE,sBAAsB,EAAE;AACjG;yEACyE;AACzE;EACE,oBAAoB,aAAa,EAAE;AACrC;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA,2DAA2D;AAC3D;;;mCAGmC;AACnC;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uCAAuC;EACvC;;;wBAGsB;EACtB,oBAAoB;AACtB;AACA;;;oCAGoC;AACpC;;;;0EAI0E;AAC1E;EAEE,0EAA0E;AAC5E;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,oDAAoD;EACpD,mBAAmB;EACnB,iDAAiD;AACnD;AACA;;6EAE6E;AAC7E,qBAAqB,QAAQ,GAAG,QAAQ,EAAE,oBAAoB,EAAE;AAChE,qBAAqB,SAAS,EAAE,QAAQ,EAAE,oBAAoB,EAAE;AAChE,qBAAqB,SAAS,EAAE,QAAQ,EAAE,oBAAoB,EAAE;;AAEhE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;;AAE7D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA,kBAAkB,kBAAkB,EAAE,cAAc,EAAE,iBAAiB,EAAE;AACzE,kBAAkB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc,EAAE;AAC/E,wBAAwB,mBAAmB,EAAE,mDAAmD,EAAE;AAClG,yBAAyB,mBAAmB,EAAE,mDAAmD,EAAE,sBAAsB,EAAE;;AAE3H;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;kEACkE;AAClE;EACE,cAAc,yBAAyB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;EACxE,mBAAmB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;EAClE,oBAAoB,kBAAkB,EAAE;EACxC,kBAAkB,kBAAkB,EAAE;AACxC;AACA;EACE,cAAc,aAAa,EAAE;AAC/B;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,UAAU;EACV,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B;;+BAE6B;EAC7B,gFAAgF;EAChF,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA,aAAa,aAAa,EAAE;AAC5B;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa,oBAAoB,EAAE,cAAc,EAAE,iBAAiB,EAAE;EACtE;IACE,cAAc;IACd,SAAW;IACX,YAAY;IACZ;2DACuD;IACvD,sEAAsE;EACxE;EACA;IACE,cAAc;IACd,mBAAmB,IAAI,wCAAwC;IAC/D,cAAc;EAChB;AACF;;AAEA,oCAAoC;AACpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mDAAmD;AACrD;AACA;EACE,WAAW,2CAA2C,EAAE;EACxD,MAAM,0CAA0C,EAAE;AACpD;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA,wBAAwB,cAAc,EAAE;;AAExC;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA,kBAAkB,cAAc,EAAE;;AAElC,iCAAiC;AACjC;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd;oCACkC;EAClC,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,8CAA8C;AAChD;AACA;2EAC2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,iCAAiC;AACnC;;AAEA,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE;;AAExF,0BAA0B,2BAA2B,EAAE;AACvD,oBAAoB,WAAW,EAAE,WAAW,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,cAAc,EAAE;;AAEvG;;0CAE0C;AAC1C;EACE,aAAa,oBAAoB,EAAE;EACnC,cAAc,kBAAkB,EAAE,aAAa,EAAE;AACnD;AACA;kEACkE;AAClE;EACE,aAAa,oBAAoB,EAAE;EACnC,0BAA0B,aAAa,EAAE;EACzC,eAAe,eAAe,EAAE;EAChC,qBAAqB,eAAe,EAAE;EACtC;IACE,aAAa;IACb,gDAAgD;IAChD,YAAY;IACZ,kBAAkB;EACpB;EACA,aAAa,mBAAmB,EAAE,QAAQ,EAAE;AAC9C;AACA;EACE,eAAe,kBAAkB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;EAC5E,oBAAoB,WAAW,EAAE;AACnC;;AAEA,yCAAyC;AACzC;EACE;;;;;;IAME,0BAA0B;EAC5B;AACF;;AAEA;EACE,cAAc,gBAAgB,EAAE;AAClC","sourcesContent":[".auth-page {\n  /* Height of the bottom strip — the illustration rests on top of it rather\n     than being buried under it. Kept in sync with .auth-footer's padding and\n     line count at each breakpoint. */\n  --auth-strip-h: 46px;\n  position: relative;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(150deg, #eef4fd 0%, #f8fbff 45%, #eaf1fb 100%);\n  overflow: hidden;\n}\n\n/* ============================================================\n   Layout has two modes, switched at one breakpoint (1100px):\n\n   MOBILE / TABLET  — single column. Centred card, with the illustration\n                      pinned to the page bottom as a background (it takes\n                      no layout space; main reserves a little room above\n                      it so the card never covers the artwork).\n   DESKTOP          — the reference composition. Hero copy on the\n                      left, card on the right, illustration pinned to\n                      the page's bottom-left, and the floating dots /\n                      bubbles / dot-grids at the reference's exact\n                      coordinates (percentages of its 1555x1011 canvas).\n   ============================================================ */\n\n/* Decorative dots/bubbles are tuned to the desktop composition, so they\n   stay off on smaller screens rather than landing on top of the card. */\n.auth-decor { display: none; }\n\n.auth-illustration {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: var(--auth-strip-h);\n  margin: 0 auto;\n  width: min(100%, 580px);\n  z-index: 1;\n  pointer-events: none;\n}\n\n@media (min-width: 1100px) {\n  .auth-decor {\n    display: block;\n    position: absolute;\n    inset: 0;\n    z-index: 1;\n    pointer-events: none;\n  }\n  .auth-illustration {\n    /* The art belongs to the hero column, so it starts on the same left edge\n       as the headline and ends where the column does — anything bleeding to\n       the page edge reads as misaligned against the copy above it.\n       (1440px container, its side padding, then the card's 500px + the 60px\n       gap make up the rest of the row.) */\n    --auth-gutter: calc(max(0px, (100vw - 1440px) / 2) + clamp(16px, 4vw, 56px));\n    --auth-hero-w: calc(\n      min(100vw, 1440px)\n      - 2 * clamp(16px, 4vw, 56px)   /* the container's side padding */\n      - 500px                         /* the sign-in card */\n      - clamp(24px, 4vw, 64px)        /* .auth-main's column gap */\n    );\n    left: var(--auth-gutter);\n    right: auto;\n    margin: 0;\n    /* Width drives height (the art is ~1.78:1) and it is pinned to the\n       bottom, so on a short window it climbs into the hero copy and the\n       badges land on the text. Cap the width by the room actually left\n       above the fold. */\n    width: min(var(--auth-hero-w), calc((100vh - 330px - var(--auth-strip-h)) * 1.95));\n  }\n}\n\n/* ---------- floating dots ---------- */\n.auth-dot {\n  position: absolute;\n  border-radius: 50%;\n  animation: auth-dot-float 6s ease-in-out infinite;\n}\n.auth-dot-teal { background: #5eead4; }\n.auth-dot-sky { background: #7dd3fc; }\n.auth-dot-blue { background: #2563eb; }\n.auth-dot-amber { background: #fbbf24; }\n\n.auth-dot-1 { left: 47.9%; top: 5.0%;  width: 9px;  height: 9px; }\n.auth-dot-2 { left: 96.7%; top: 4.9%;  width: 9px;  height: 9px;  animation-delay: -1.2s; }\n.auth-dot-3 { left: 57.2%; top: 30.4%; width: 15px; height: 15px; animation-delay: -2.4s; }\n.auth-dot-4 { left: 52.1%; top: 39.4%; width: 7px;  height: 7px;  animation-delay: -3.6s; }\n.auth-dot-5 { left: 94.7%; top: 15.2%; width: 9px;  height: 9px;  animation-delay: -4.8s; }\n.auth-dot-6 { left: 96.9%; top: 79.2%; width: 9px;  height: 9px;  animation-delay: -2.0s; }\n\n@keyframes auth-dot-float {\n  0%, 100% { transform: translateY(0); opacity: 0.8; }\n  50% { transform: translateY(-6px); opacity: 1; }\n}\n\n/* ---------- dotted grid patches ---------- */\n.auth-grid {\n  position: absolute;\n  background-image: radial-gradient(rgba(96, 165, 250, 0.4) 1.6px, transparent 1.6px);\n  background-size: 13px 13px;\n}\n.auth-grid-1 { left: 42.4%; top: 7.7%;  width: 86px; height: 66px; }\n.auth-grid-2 { left: 95.8%; top: 54.9%; width: 62px; height: 72px; }\n.auth-grid-3 { left: 95.0%; top: 68.2%; width: 74px; height: 86px; }\n\n/* ---------- faint ring on the right ---------- */\n.auth-ring {\n  position: absolute;\n  left: 90.5%;\n  top: 21%;\n  width: 280px;\n  height: 280px;\n  border-radius: 50%;\n  border: 1px solid rgba(147, 197, 253, 0.22);\n}\n\n/* ---------- dashed connector between the plane bubble and its dot ---------- */\n.auth-connector {\n  position: absolute;\n  left: 51.4%;\n  top: 27.4%;\n  width: 6.6%;\n  height: 4.2%;\n}\n\n/* ---------- icon bubbles ---------- */\n.auth-bubble {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.72);\n  border: 1px solid rgba(219, 234, 254, 0.9);\n  box-shadow: 0 16px 32px -20px rgba(30, 64, 175, 0.5);\n  color: #3b82f6;\n  animation: auth-bubble-float 7s ease-in-out infinite;\n}\n.auth-bubble-box   { left: 53.3%; top: 6.7%;  width: 58px; height: 58px; }\n.auth-bubble-plane { left: 47.6%; top: 23.7%; width: 72px; height: 72px; animation-delay: -2.3s; }\n.auth-bubble-cube  {\n  left: 94.5%;\n  top: 36.3%;\n  width: 72px;\n  height: 72px;\n  color: #8b5cf6;\n  background: rgba(246, 244, 255, 0.78);\n  border-color: rgba(221, 214, 254, 0.9);\n  animation-delay: -4.6s;\n}\n.auth-bubble-mini  { left: 47.0%; top: 50.9%; width: 38px; height: 38px; animation-delay: -1.1s; }\n/* On narrower desktops the card reaches the right gutter, so the cube\n   bubble would sit half-hidden behind it — drop it until there's room. */\n@media (max-width: 1399px) {\n  .auth-bubble-cube { display: none; }\n}\n.auth-bubble-mini-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #93c5fd;\n}\n\n@keyframes auth-bubble-float {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-9px); }\n}\n\n/* ---------- illustration + its status badges ---------- */\n/* The source artwork is far more saturated than the reference comp, which\n   shows it as a pale, hazy scene that dissolves into the page. Desaturating\n   and fading the right edge reproduces that, and keeps the artwork from\n   competing with the login card. */\n.auth-illustration-img {\n  display: block;\n  width: 100%;\n  height: auto;\n  opacity: 0.88;\n  filter: saturate(0.78) brightness(1.04);\n  /* The art feathers out on three sides but the sea and road are sliced\n     straight across at 98% of its height. Push that strip past the bottom of\n     the page (which clips it) so the scene bleeds off the edge instead of\n     ending on a line. */\n  margin-bottom: -2.5%;\n}\n/* This artwork already feathers out on its own left and bottom — only the\n   plane's nose grazes the right edge of the canvas (at 30-32% of its height),\n   which would read as a straight cut. Soften just that strip; fading any more\n   washes the plane and truck out. */\n/* The art feathers out on its own left and top, and the sliced bottom is\n   pushed off the page (see margin-bottom above) — but the road and cloud bank\n   still run solid into the right edge of the canvas, which reads as a straight\n   cut in the middle of the page. Fade just the last tenth: the truck ends at\n   88% so it stays sharp. Re-check the edges if the artwork is replaced. */\n.auth-illustration-img {\n  -webkit-mask-image: linear-gradient(to right, #000 0%, #000 97%, transparent 100%);\n  mask-image: linear-gradient(to right, #000 0%, #000 97%, transparent 100%);\n}\n\n.auth-badge {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  background: #ffffff;\n  border-radius: 13px;\n  padding: 9px 14px 9px 10px;\n  box-shadow: 0 16px 30px -16px rgba(15, 23, 42, 0.38);\n  white-space: nowrap;\n  animation: auth-badge-bob 6s ease-in-out infinite;\n}\n/* Each badge is anchored just clear of the vehicle it labels — in the artwork\n   the ship sits at 5-31% / 60-88%, the plane at 50-97% / 8-33% and the truck\n   at 70-88% / 70-88% — so they read as callouts instead of floating loose. */\n.auth-badge-ship   { left: 9%;  top: 47%; animation-delay: -1s; }\n.auth-badge-ontime { left: 24%; top: 19%; animation-delay: -3s; }\n.auth-badge-truck  { left: 50%; top: 63%; animation-delay: -5s; }\n\n.auth-badge-icon {\n  width: 30px;\n  height: 30px;\n  border-radius: 9px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.auth-badge-icon-soft { background: #e0f2fe; color: #0284c7; }\n.auth-badge-icon-solid { background: #2563eb; color: #ffffff; }\n.auth-badge-icon-dark { background: #f1f5f9; color: #334155; }\n\n.auth-badge-title {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #1e293b;\n  line-height: 1.25;\n}\n.auth-badge-sub { font-size: 0.72rem; color: #94a3b8; line-height: 1.25; }\n.auth-badge-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }\n.auth-badge-dot-green { background: #22c55e; animation: auth-pulse-dot 1.8s ease-in-out infinite; }\n.auth-badge-dot-orange { background: #f97316; animation: auth-pulse-dot 1.8s ease-in-out infinite; animation-delay: -0.9s; }\n\n@keyframes auth-badge-bob {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-6px); }\n}\n\n/* Badges scale down with the smaller illustration on tablets, and drop out\n   on phones where the art is too small to carry three callouts. */\n@media (max-width: 1099px) {\n  .auth-badge { padding: 7px 11px 7px 8px; gap: 7px; border-radius: 11px; }\n  .auth-badge-icon { width: 26px; height: 26px; border-radius: 8px; }\n  .auth-badge-title { font-size: 0.72rem; }\n  .auth-badge-sub { font-size: 0.66rem; }\n}\n@media (max-width: 639px) {\n  .auth-badge { display: none; }\n}\n\n/* ---------- main layout ---------- */\n.auth-main {\n  position: relative;\n  z-index: 2;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: clamp(24px, 4vw, 64px);\n  /* Bottom padding keeps the card clear of the artwork pinned below it.\n     The art's top ~24% is transparent sky, so a small overlap is harmless\n     on very short viewports. */\n  padding: clamp(32px, 5vw, 72px) clamp(16px, 4vw, 56px) clamp(130px, 27vw, 210px);\n  max-width: 1440px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.auth-hero { display: none; }\n.auth-card-slot {\n  width: 100%;\n  max-width: 500px;\n  display: flex;\n  justify-content: center;\n}\n\n@media (min-width: 1100px) {\n  .auth-main { align-items: stretch; padding-top: 0; padding-bottom: 0; }\n  .auth-hero {\n    display: block;\n    flex: 1 1 0;\n    min-width: 0;\n    /* Carries the row's top padding on its own, so the card beside it stays\n       centred between the top of the page and the strip. */\n    padding-top: calc(clamp(20px, 3.5vw, 44px) + clamp(14px, 2.2vw, 34px));\n  }\n  .auth-card-slot {\n    flex: 0 0 auto;\n    align-items: center;   /* equal room above and below the card */\n    padding-top: 0;\n  }\n}\n\n/* ---------- hero copy ---------- */\n.auth-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #ecfdf3;\n  color: #15803d;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  padding: 7px 15px;\n  border-radius: 999px;\n  margin-bottom: 20px;\n}\n.auth-pill-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #22c55e;\n  animation: auth-pulse-dot 1.8s ease-in-out infinite;\n}\n@keyframes auth-pulse-dot {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55); }\n  50% { box-shadow: 0 0 0 5px rgba(34, 197, 94, 0); }\n}\n\n.auth-headline {\n  font-size: clamp(2.2rem, 3.5vw, 3.25rem);\n  font-weight: 800;\n  color: #0f172a;\n  line-height: 1.1;\n  letter-spacing: -0.02em;\n  margin: 0 0 16px;\n}\n.auth-headline-accent { color: #2563eb; }\n\n.auth-subtext {\n  max-width: 480px;\n  color: #64748b;\n  font-size: 1rem;\n  line-height: 1.6;\n  margin: 0 0 28px;\n}\n\n.auth-modes {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px 18px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #334155;\n  letter-spacing: 0.01em;\n}\n.auth-mode {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n.auth-modes-sep { color: #93c5fd; }\n\n/* ---------- footer ---------- */\n.auth-footer {\n  position: relative;\n  z-index: 3;\n  padding: 13px 0;\n  font-size: 0.74rem;\n  color: #64748b;\n  /* The artwork runs underneath, so the strip needs its own ground rather\n     than a halo behind each word. */\n  background: rgba(255, 255, 255, 0.86);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-top: 1px solid rgba(226, 232, 240, 0.9);\n}\n/* Same max-width and side padding as .auth-main, so the first service point\n   starts on the hero headline's edge and the tagline ends on the card's. */\n.auth-footer-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 0 clamp(16px, 4vw, 56px);\n}\n\n.auth-footer-item { display: flex; align-items: center; gap: 10px; white-space: nowrap; }\n\n.auth-footer-item-right { flex-direction: row-reverse; }\n.auth-footer-line { width: 30px; height: 2px; background: #60a5fa; border-radius: 1px; flex-shrink: 0; }\n\n/* Below desktop the footer sits over the busiest part of the pinned\n   artwork (ship/truck), so it gets a soft fade-to-page backdrop that also\n   dissolves the art's hard bottom edge. */\n@media (max-width: 1099px) {\n  .auth-page { --auth-strip-h: 66px; }\n  .auth-modes { font-size: 0.76rem; gap: 6px 14px; }\n}\n/* On a phone the four points need the whole strip; the tagline drops out and\n   the points pair up two per row instead of stacking four deep. */\n@media (max-width: 639px) {\n  .auth-page { --auth-strip-h: 56px; }\n  .auth-footer-item-right { display: none; }\n  .auth-footer { padding: 10px 0; }\n  .auth-footer-inner { padding: 0 14px; }\n  .auth-modes {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 4px 8px;\n    font-size: 0.62rem;\n  }\n  .auth-mode { white-space: normal; gap: 6px; }\n}\n@media (max-width: 480px) {\n  .auth-footer { font-size: 0.62rem; padding-left: 16px; padding-right: 16px; }\n  .auth-footer-line { width: 14px; }\n}\n\n/* ---------- reduced motion ---------- */\n@media (prefers-reduced-motion: reduce) {\n  .auth-dot,\n  .auth-bubble,\n  .auth-badge,\n  .auth-badge-dot-green,\n  .auth-badge-dot-orange,\n  .auth-pill-dot {\n    animation: none !important;\n  }\n}\n\n@media (max-width: 1279px) and (min-width: 1100px) {\n  .auth-modes { max-width: 380px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
